import { ticketActionTypes } from './ticket.types';
import { logOut } from '../user/user.actions';
import { toast } from 'react-toastify';
import http, { httpMovidesk } from '../../services/http';
import { normalizeTicketAssigneeForList } from '../../utils/ticketAssignee';
import { mensagemDoErroDaApi } from '../../utils/mensagemDoErroDaApi';
import { setLoading, setNotLoading } from '../loading/loading.actions';

export const selectTickets = state => state.tickets.tickets;
export const selectViewedTickets = state => state.tickets.viewedTickets;

export const mapPriority = (priority) => {
  switch (priority) {
    case 0:
      return 'Baixa';
    case 1:
      return 'Média';
    case 2:
      return 'Alta';
    case 3:
      return 'Urgente';
    default:
      return 'Desconhecida';
  }
};

export const mapStatus = (status) => {
  const n = Number(status);
  switch (n) {
    case 0:
      return 'Fechado';
    case 1:
      return 'Aberto';
    case 2:
      return 'Pendente';
    case 3:
      return 'Resolvido';
    case 4:
      return 'Cancelado';
    default:
      return 'Desconhecido';
  }
};

const setTickets = tickets => {
  return {
    type: ticketActionTypes.SET_TICKETS,
    payload: tickets
  };
};

export const setViewedTickets = tickets => {
  return {
    type: ticketActionTypes.SET_VIEWED_TICKETS,
    payload: tickets
  };
}

export const fetchTickets = (scope = 'active') => {
  return async dispatch => {
    dispatch({ type: ticketActionTypes.FETCH_TICKETS_START });
    try {
      const response = await http.get(scope ? `/ticket?scope=${scope}` : '/ticket');
      const tickets = response.data.map((ticket) => normalizeTicketAssigneeForList(ticket));
      dispatch({ type: ticketActionTypes.FETCH_TICKETS_SUCCESS, payload: tickets });
    } catch (error) {
      if (error.response && (error.response.status === 401 || error.response.data.error === 'Token Error')) {
        dispatch(logOut());
      } else {
        dispatch({ type: ticketActionTypes.FETCH_TICKETS_FAIL, payload: error });
        console.log(error);
      }
    }
  };
};

export const createTicket = (ticket) => {
  return async dispatch => {
    try {
      await http.post('/ticket', ticket);
      dispatch(fetchTickets());
    } catch (error) {
      if (error.response && (error.response.status === 401 || error.response.data.error === 'Token Error')) {
        dispatch(logOut());
      } else {
        console.log(error);
      }
    }
  };
};

export const editTicket = (ticket) => {
  return async dispatch => {
    try {
      dispatch(setLoading());
      await http.put(`/ticket/${ticket.id}`, ticket);
      dispatch(fetchTickets());
    } catch (error) {
      if (error.errorMessage === 'Unauthorized' || error.errorStatus === 401 || (error.response && (error.response.status === 401 || error.response.data?.error === 'Token Error'))) {
        dispatch(logOut());
      } else if (error.errorStatus === 403) {
        const msg = error.responseData?.message || 'Você não tem permissão para editar este ticket.';
        toast.error(msg);
        return Promise.reject(error);
      } else {
        /*
         * O servidor recusou e EXPLICOU: mostra a explicação.
         *
         * Até 19/10 isto era só um `console.log`. Quando a API passou a
         * recusar o fechamento do chamado do chat sem serviço e categoria, o
         * cartão arrastado no kanban simplesmente não se movia -- sem erro,
         * sem aviso, sem pista. Quem arrasta conclui que o kanban quebrou.
         *
         * Sem mensagem do servidor (rede caiu, 500 mudo) nada é inventado
         * aqui: ver `utils/mensagemDoErroDaApi`.
         */
        const recado = mensagemDoErroDaApi(error);
        if (recado) toast.error(recado);

        console.log(error);
        return Promise.reject(error);
      }
    } finally {
      dispatch(setNotLoading());
    }
  };
};

export const validateUser = (id) => {
  return async dispatch => {
    try {
      const response = await httpMovidesk.get(`persons?token=${process.env.REACT_APP_MOVIDESK_TOKEN}&id=${id}`);
      return response.data.id;
    } catch (error) {
      console.log(error);
      return false;
    }
  };
}